import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-mist" data-id="element-119" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-120" data-mp="223em7ne0hd4i">
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-cream border border-cta/20 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-lg shadow-navy/5" data-id="element-121" data-mp="222dbxl4tkunu">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-cta" data-id="element-122" data-mp="1j4ah2pplc3i4" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-navy text-cta mb-8" data-id="element-123" data-mp="1edu23164g9tn">
            <ShieldCheck size={48} data-id="element-124" data-mp="qnznof65md7a" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-navy uppercase" data-id="element-125" data-mp="qmew8yf4zadn">
            7-Day Guarantee
          </h2>
          <div className="space-y-6 text-lg text-ink max-w-2xl mx-auto" data-id="element-126" data-mp="ozjfev315uuf">
            <p data-id="element-127" data-mp="oxf8s5dqyhqg">You have 7 days to review the material after purchase.</p>
            <p className="font-medium text-navy" data-id="element-128" data-mp="txbc02eme54y">
              If the material you receive is incorrect, defective, incomplete or materially
              different from what was advertised, contact support within the applicable period and
              the case will be reviewed according to the guarantee terms.
            </p>
            <p className="text-sm text-slate-500 mt-8" data-id="element-129" data-mp="630a6gvckr35">The product is delivered digitally.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}